import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { faPen } from "components/icon-library";
import Block from "components/layout/block";
import ValuePair from "components/valuepair";
import { FunctionComponent, useState } from "react";
import { useListUser } from "stores/hooks/list-user";
import { useTranslate } from "stores/hooks/translation";
import { StyledIcon } from "./tech-block.styles";
import EditLocaleModal from "../modals/edit-locale-modal";

interface TechBlockProps {}

const TechBlock: FunctionComponent<TechBlockProps> = () => {
  const listUser = useListUser();
  const translate = useTranslate();
  const [editLocale, toggleEditLocale] = useState(false);

  if (!listUser) {
    return null;
  }

  return (
    <Block title="Tekniset tiedot">
      <Grid>
        <Row>
          <Col>
            <ValuePair label="UUID" copy>
              {listUser.uuid}
            </ValuePair>
          </Col>
          <Col>
            <ValuePair label="Kieli">
              {translate(`locale_${listUser.locale}`) || "-"}{" "}
              <StyledIcon icon={faPen} onClick={() => toggleEditLocale(true)} />
            </ValuePair>
          </Col>
        </Row>
      </Grid>
      {editLocale && (
        <EditLocaleModal onClose={async () => toggleEditLocale(false)} />
      )}
    </Block>
  );
};

export default TechBlock;
